import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LabelExpressionUtilityService {
    title = 'affectedLotLabelExpressionBuilder';

    pointsToPixelsConverter(fontSizeInPoints: number) {
        return fontSizeInPoints * 1.333333;
    }

    encodeSpecialCharacters(text: any) {
        return String(text)
            .replace(/&(?!amp;)/gi, '&amp;')
            .replace(/</gi, '&lt;')
            .replace(/>/gi, '&gt;');
    }

    round(value: number, decimals: number) {
        return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
    }

    isLookupItemDescriptionMatch(lookupItem, annoDisplayValue) {
        return lookupItem.description === annoDisplayValue || lookupItem.displayLabel === annoDisplayValue;
    }

    isLookupItemIdMatch(lookupItem: any, annoValue: string) {
        return lookupItem.id === annoValue;
    }

    formatLabel(value: string, size: number, normal: boolean) {
        let labelExpression = value
            ? normal
                ? `<FNT name='Arial' size='${size}'>${this.encodeSpecialCharacters(value)}</FNT>`
                : `<FNT name='Arial' size='${size}'><ITA>${this.encodeSpecialCharacters(value)}</ITA></FNT>`
            : '';
        return labelExpression;
    }

    getLabelProperties(fontSize: string, fontStyle: string, textAnchor: string, attributes: string) {
        return {
            style: {
                fontSize: fontSize,
                fontStyle: fontStyle,
                textAnchor: textAnchor
            },
            value: attributes
        };
    }
}
